import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c477c422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "last-assessment-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("milestonePlanner.milestoneGrid.footer.lastAssessment", {
        assessmentDate: _ctx.date,
      })), 1))
}